import React, { useState } from "react";
import ParcelStatusPage from "../../components/common/parcelStatusPages";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Routes } from "../../router/routes";
import { setFiltersInStore } from "../../actions/filters";
import { updateSpinnerState } from "../../actions/spinner";
import { createBuyBackPendingParcel, getParcelsByStatusAndSubStatus } from "../../parse-functions/parcels";
import { markParcelAsDisabled, setParcelsForStagesInStore } from "../../actions/parcels";
import { convertArrayToObj } from "../../utils/json";
import { updateToastInfo } from "../../actions/settings";
import { returnEndOfDay, returnStartOfDay } from "../../utils/datetime";
import { returnWarehouseDropdownOptions } from "../../utils/warehouse";
import ModelChangePickupModal from "./modelChangePickupModal";
import { modelChangePendingTableColumns } from "./modelChangeUtils";

const ModelChangeListRequest = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const pageType = "modelChange";
    

    const breadCrumbItems = [{
        title: t("Model Change"),
        link: Routes.ModelChange.Pending.path
    }];
    
    const [selectedParcelId, setSelectedParcelId] = useState(null);
    const storeCode = useSelector((state) => state?.user?.warehouse?.warehouseCode || "");
    const filtersValue = useSelector((state) => state.filters?.[pageType]);
    const parcels = useSelector((state) => state?.parcels?.[pageType] || {});
    const [showRescheduleModal, setShowRescheduleModal] = useState(false);
    const warehouse = useSelector((state) => state?.user?.warehouse || {});
    const otherWarehouses = useSelector((state) => state?.user?.otherWarehousesInZone || {});

    const handleFiltersSubmit = (startDate, endDate) => {
        dispatch(setFiltersInStore({
            pageType,
            data: {
              startDate: new Date(startDate),
              endDate: new Date(endDate)
            }
          }))
        getAvailableParcels(startDate, endDate);
    };
    const getAvailableParcels = async (startDate, endDate) => {
        dispatch(updateSpinnerState(true));
        try {
            const filters = {
                subStatus: [pageType],
                storeCode,
                startDate: new Date(startDate),
                endDate: new Date(endDate),
                zone: warehouse.zone,
                isRescheduled: "false"
            };
            const parcels = await getParcelsByStatusAndSubStatus(filters);
            dispatch(setParcelsForStagesInStore(pageType, convertArrayToObj(JSON.parse(JSON.stringify(parcels)), "objectId")))
            dispatch(updateSpinnerState(false));
            dispatch(updateToastInfo({
                show: true,
                type: 'success',
                title: t('Orders fetched'),
                message: t("You can schedule your parcels here for which model change has been requested")
            }))

        } catch (e) {
            dispatch(updateSpinnerState(false));
            dispatch(updateToastInfo({
                show: true,
                type: 'danger',
                title: t('Error'),
                message: t(e.message)
            }))
        }
    }
    const onRowSelect = (value, objectId) => {
        if (selectedParcelId) {
            dispatch(updateToastInfo({
                show: true,
                type: 'danger',
                title: t('Only 1 item allowed'),
                message: t("Please deselect other item before choosing this")
            }))
        } else {
            if (value) {
                setSelectedParcelId(objectId);
            } else {
                setSelectedParcelId(null);
            }
        }
    }
    const onRefreshClick = () => {
        const currentStartDate = filtersValue.startDate ? new Date(filtersValue.startDate): returnStartOfDay(new Date());
        const currentEndDate = filtersValue.endDate ? new Date(filtersValue.endDate) : returnEndOfDay(new Date());
        getAvailableParcels(currentStartDate, currentEndDate)
    }
    const handleShowRescheduleModal = () => {
        setShowRescheduleModal(false);
    }
    const onRescheduleConfirm = async (data) => {
        dispatch(updateSpinnerState(true));
        try {
            const formData = {
                ...data,
                warehouse,
                parcelObjectId: selectedParcelId,
                mode: "modelChange",
                newDate: new Date()
            }
            await createBuyBackPendingParcel(formData);
            dispatch(markParcelAsDisabled(pageType, selectedParcelId));
            setShowRescheduleModal(false);
            dispatch(updateToastInfo({
                show: true,
                type: 'success',
                title: t('Model Change Pickup Scheduled'),
                message: t("This parcel's pickup has been scheduled for pickup for the chosen date")
            }))
            dispatch(updateSpinnerState(false));

        } catch(e) {
            dispatch(updateSpinnerState(false));
        }
    };
    const handleItemBulkUpdate = (actionId) => {
        if (selectedParcelId) {
            switch (actionId) {
                case "schedule": {
                    setShowRescheduleModal(true);
                    break;
                }
                default: {
                    dispatch(updateToastInfo({
                        show: true,
                        type: 'danger',
                        title: t('Select an Action'),
                        message: t("Please select an action from the dropdown")
                    }))
                    break;
                }
            }
        } else {
            dispatch(updateToastInfo({
                show: true,
                type: 'danger',
                title: t('Select Item'),
                message: t("Please select an item to take action")
            }))
        }
    }
    return (
        <>
            <ParcelStatusPage
                pageType={pageType}
                filtersValue={filtersValue}
                filterSubmit={handleFiltersSubmit}
                tableData={parcels}
                tableColumns={modelChangePendingTableColumns(onRowSelect)}
                handleRefresh={onRefreshClick}
                pageTitle={t("Model Change Pickup Pending")}
                breadCrumbItems={breadCrumbItems}
                pageSubTitle={t("All the parcels for which the model change pickup is pending")}
                searchPlaceHolder={t("Search by Invoice No. in Database")}
                handleItemBulkUpdate={handleItemBulkUpdate}
                bulkActionOptions={[{
                    label: "Schedule",
                    value: "schedule"
                }]}
                enableBulkActions={selectedParcelId && Object.keys(parcels)?.length > 0}
            />
            <ModelChangePickupModal
                disableTargetDropdown={false}
                targetDropdownOptions={returnWarehouseDropdownOptions(otherWarehouses)}
                selectedParcelId={selectedParcelId}
                pageStatus={pageType}
                showModal={showRescheduleModal}
                closeModal={handleShowRescheduleModal}
                onConfirm={onRescheduleConfirm} />
        </>
    )
};
export default ModelChangeListRequest